import styled from "styled-components";

export const SocialStyled = styled.div`
  width: 100%;
  a {
    display: flex;
    flex-direction: row;
    padding: 8px 0;
  }
  h4 {
    width: 25%;
  }
  div p {
    width: 75%;
  }
  span {
    position: fixed;
    bottom: 100px;
    right: 80px;
    transition: cubic-bezier(0.39, 0.575, 0.565, 1);
  }
  span a {
    color: tomato;
    border: none;
    background: none;
    font-size: 1.2rem;
    font-family: "Space Mono", monospace;
  }
  span:hover {
    scale: 0.9;
  }

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 768px) {
    span {
      bottom: 50px;
      right: 50px;
    }
  }
  @media only screen and (max-width: 600px) {
    a {
      flex-direction: column;
    }
    h4,
    div p {
      width: 100%;
    }
    span {
      bottom: 30px;
      right: 30px;
    }
  }
`;
